module.exports = __webpack_public_path__ + "static/media/turfboss.db159951.pdf";